import ComplianceOverview from "@/components/probaworkflows_base_components/ComplianceOverview/ComplianceOverview.vue";
import UserActivityLogs from "@/views/global/management/user_activity_logs/UserActivityLogs.vue";
import EntityReviewQuote from "@/views/probaworkflows_base/entity/entity_applications/entity_review_quote/EntityReviewQuote.vue";
import InvoiceOverview from "@/views/probaworkflows_base/invoicing/invoice_overview/InvoiceOverview.vue";
import InvoiceSteps from "@/views/probaworkflows_base/invoicing/invoice_steps/InvoiceSteps.vue";
import TrustInvoicing from "@/views/probaworkflows_base/invoicing/trust_invoicing/TrustInvoicing.vue";
import AssignComplianceRules from "@/views/probaworkflows_base/management/compliance_management/assign_compliance_rules/AssignComplianceRules.vue";
import ComplianceNotifications from "@/views/probaworkflows_base/management/compliance_management/compliance_notifications/ComplianceNotifications.vue";
import ComplianceRules from "@/views/probaworkflows_base/management/compliance_management/compliance_rules/ComplianceRules.vue";
import TrustCompliance from "@/views/probaworkflows_base/management/compliance_management/trust_compliance/TrustCompliance.vue";
import ViewComplianceRequirements from "@/views/probaworkflows_base/management/compliance_management/view_compliance_requirements/ViewComplianceRequirements.vue";
import ManageWorkflows from "@/views/probaworkflows_base/management/entity_management/approval_rules_management/manage_workflows/ManageWorkflows.vue";
import ManageQuestions from "@/views/probaworkflows_base/management/manage_questions/ManageQuestions.vue";
import MasterOfficeSubmissions from "@/views/probaworkflows_base/management/master_office_submissions/MasterOfficeSubmissions.vue";
import SigningWorkflow from "@/views/probaworkflows_base/management/signing_workflow_management/signing_workflow/SigningWorkflow.vue";
import StatusManagement from "@/views/probaworkflows_base/management/status_management/StatusManagement.vue";
import ApplicationAssignment from '@/views/probaworkflows_base/management/trust_applications/application_assignment/ApplicationAssignment.vue';
import ApplicationLog from "@/views/probaworkflows_base/management/trust_applications/application_log/ApplicationLog.vue";
import MasterSubmissions from "@/views/probaworkflows_base/management/trust_applications/master_submissions/MasterSubmissions.vue";
import OverviewOfProfile from "@/views/probaworkflows_base/management/trust_applications/overview_of_profile/OverviewOfProfile.vue";
import PendingApplications from "@/views/probaworkflows_base/management/trust_applications/pending_applications/PendingApplications.vue";
import SignedContract from "@/views/probaworkflows_base/management/trust_applications/signed_contract/SignedContract.vue";
import VerificationOverview from "@/views/probaworkflows_base/management/trust_applications/verification_managment/verification_overview/VerificationOverview.vue";
import VerificationResults from "@/views/probaworkflows_base/management/trust_applications/verification_managment/verification_results/VerificationResults.vue";
import ResolveRequests from "@/views/probaworkflows_base/management/trust_applications/view_requested_information/resolve_requests/ResolveRequests.vue";
import ViewRequests from "@/views/probaworkflows_base/management/trust_applications/view_requested_information/view_requests/ViewRequests.vue";
import ViewResolvedRequests from "@/views/probaworkflows_base/management/trust_applications/view_requested_information/view_resolved_requests/ViewResolvedRequests.vue";
import ManualVerification from "@/views/probaworkflows_base/verification/manual_verification/ManualVerification.vue";
import probaworkflowssupplemental from "./probaworkflowssupplemental";

const probaworkflowsadditional = [
  //signing workflow
  {
    path: "signing_workflow",
    name: "signing_workflow",
    component: SigningWorkflow,
    meta: {
      breadcrumb: "Documents Workflow",
      branch: 'configure',
      isTab: true
    }
  },
  // trust compliance
  {
    path: "/trust_compliance",
    name: "trust_compliance",
    component: TrustCompliance,
  },
  {
    path: "/view_compliance_requirements",
    name: "view_compliance_requirements",
    component: ViewComplianceRequirements,
  },
  {
    path: "/compliance_notifications",
    name: "compliance_notifications",
    component: ComplianceNotifications,
  },
  {
    path: "/compliance_overview",
    name: "compliance_overview",
    component: ComplianceOverview,
  },
  {
    path: "/compliance_rules",
    name: "compliance_rules",
    component: ComplianceRules,
  },
  {
    path: "/assign_compliance_rules",
    name: "assign_compliance_rules",
    component: AssignComplianceRules,
  },
  {
    path: "/manual_verification",
    name: "manual_verification",
    component: ManualVerification,
  },
  {
    path: "/pending_applications",
    name: "pending_applications",
    component: PendingApplications,
    meta: {
      breadcrumb: "Application Management",
      branch: 'overview',
      isTab: true
    }
  },
  {
    path: "/overview_of_profile",
    name: "overview_of_profile",
    component: OverviewOfProfile,
    meta: {
      breadcrumb: "Overview Of Profile",
      branch: 'overview',
      isDynamic: true
    }
  },
  {
    path: "/master_submissions",
    name: "master_submissions",
    component: MasterSubmissions,
  },
  {
    path: "/master_office_submissions",
    name: "master_office_submissions",
    component: MasterOfficeSubmissions,
  },
  {
    path: "/signed_contract",
    name: "signed_contract",
    component: SignedContract,
  },
  {
    path: "/view_requests",
    name: "view_requests",
    component: ViewRequests,
  },
  {
    path: "/resolve_requests",
    name: "resolve_requests",
    component: ResolveRequests,
    meta: {
      breadcrumb: "Resolve Requests",
      branch: 'overview',
      isTab: true
    }
  },
  {
    path: "/view_resolved_requests",
    name: "view_resolved_requests",
    component: ViewResolvedRequests,
    meta: {
      breadcrumb: "View Resolved Requests",
      branch: 'overview',
      isTab: true
    }
  },
  {
    path: "/application_log",
    name: "application_log",
    component: ApplicationLog,
  },
  {
    path: "/user_activity_logs",
    name: "user_activity_logs",
    component: UserActivityLogs,
  },
  {
    path: "/manage_questions",
    name: "ManageQuestions",
    component: ManageQuestions,
    meta: {
      breadcrumb: "Question Management",
      branch: 'configure',
      isTab: true
    }
  },
  {
    path: "/invoicing",
    name: "invoicing",
    component: TrustInvoicing,
  },
  {
    path: "/status_management",
    name: "status_management",
    component: StatusManagement,
    meta: {
      breadcrumb: "Status Management",
      branch: 'configure',
      isTab: true
    }
  },
  {
    path: "/manage_workflows",
    name: "manage_workflows",
    component: ManageWorkflows,
  },
  {
    path: "/invoice_steps",
    name: "invoice_steps",
    component: InvoiceSteps,
  },
  {
    path: "/entity_review_quote",
    name: "entity_review_quote",
    component: EntityReviewQuote,
  },
  {
    path: "/invoice_overview",
    name: "invoice_overview",
    component: InvoiceOverview,
  },
  {
    path: "/verification_overview",
    name: "verification_overview",
    component: VerificationOverview,
  },
  {
    path: "/verification_results",
    name: "verification_results",
    component: VerificationResults,
  },
  {
    path: "/application_assignment",
    name: "application_assignment",
    component: ApplicationAssignment,
  },
  ...probaworkflowssupplemental,
];

export default probaworkflowsadditional;
